<template>
	<div>
		<case-form :schema="schemaFromTo" size="xsmall" />
		<div class="xs-12 fs5 fw7 mt6 mb2">Jewelly</div>
		<case-form :schema="schemaInsureds" size="xsmall" />
		<j-button
			@click="numberOfInsureds++"
			type="primary"
			size="small"
			class="mt6"
			>Add</j-button
		>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JButton from "@/components/JButton/"

export default {
	name: "PJProposalInsureds",
	components: { CaseForm, JButton },

	data() {
		return {
			numberOfInsureds: this.$store?.state?.caseManagement?.case?.insureds
				?.length
				? this.$store?.state?.caseManagement?.case?.insureds?.length
				: 1
		}
	},

	computed: {
		insureds() {
			return this.$store?.state?.caseManagement?.case?.insureds
		},

		schemaFromTo() {
			return [
				{
					label: "Property Mostly Worn By",
					component: "text",
					bindTo: "case.facts.propertyMostWornBy"
				},
				{
					label: "Refered By",
					component: "text",
					bindTo: "case.facts.referedBy"
				},
				{
					label: "Relationship With Proposer",
					component: "text",
					bindTo: "case.facts.relationshipWithProposer"
				}
			]
		},

		schemaInsureds() {
			let schema = []
			for (let i = 0; i < this.numberOfInsureds; i++) {
				schema.push(...this.buildSchemaInsured(i))
			}
			return schema
		}
	},

	methods: {
		buildSchemaInsured(i) {
			return [
				{
					label: "Select Jewel " + (i + 1),
					component: "entitySelect",
					bindTo: `case.insureds[${i}]`,
					entity: `case.insureds[${i}]`,
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "Value",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.valueInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "value"
						},
						createOptions: {
							type: "value",
							dataType: "number"
						}
					}
				},
				{
					label: "Description",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.descriptionInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "description"
						},
						createOptions: {
							type: "description",
							dataType: "string"
						}
					}
				},
				i < this.numberOfInsureds - 1 && {
					component: "html",
					props: {
						content: "<div class='bb1 bc7 xs-12'/>"
					},
					bindTo: ""
				}
			]
		}
	},

	watch: {
		insureds: {
			handler() {
				this.$store?.state?.caseManagement?.case?.insureds?.length
					? this.$store?.state?.caseManagement?.case?.insureds?.length
					: 1
			}
		}
	}
}
</script>
